import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import "./Home.css";
import "./Auth.css";

const A = "/remy";

const UserIcon = (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
  </svg>
);
const MailIcon = (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" />
  </svg>
);
const LockIcon = (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(fullName, email, password);
      toast.success("Account created");
      navigate("/onboarding");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="remy-home remy-auth" data-testid="signup-page">
      <header className="remy-auth__nav">
        <Link to="/" className="remy-auth__brand" data-testid="signup-brand">
          <img className="ic" src={`${A}/icon.png`} alt="" aria-hidden />
          <img className="wd" src={`${A}/wordmark.png`} alt="Remy" />
        </Link>
      </header>

      <main className="remy-auth__main">
        <div className="remy-auth__card">
          <h1 className="remy-auth__title">Create your account</h1>
          <p className="remy-auth__sub">Set up your Remy companion in under a minute.</p>

          <form onSubmit={submit} data-testid="signup-form">
            <label className="rh-input rh-input--mb" htmlFor="name">
              {UserIcon}
              <input id="name" required value={fullName} data-testid="signup-name"
                autoComplete="name" onChange={(e) => setFullName(e.target.value)} placeholder="Jordan Rivera" />
            </label>
            <label className="rh-input rh-input--mb" htmlFor="email">
              {MailIcon}
              <input id="email" type="email" required value={email} data-testid="signup-email"
                autoComplete="email" onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </label>
            <label className="rh-input rh-input--mb" htmlFor="password">
              {LockIcon}
              <input id="password" type="password" required minLength={8} value={password}
                data-testid="signup-password" autoComplete="new-password"
                onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" />
            </label>
            <button type="submit" className="rh-btn rh-btn--block" disabled={loading} data-testid="signup-submit">
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>

          <p className="remy-auth__foot">
            Already have an account?{" "}
            <Link to="/login" data-testid="go-login">Log in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
